/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PhaseWithContent } from '../../models/phase-with-content';

export interface IlsControllerDuplicatePhaseToIls$Params {
  ilsId: string;
  sourcePhaseId: string;
}

export function ilsControllerDuplicatePhaseToIls(http: HttpClient, rootUrl: string, params: IlsControllerDuplicatePhaseToIls$Params, context?: HttpContext): Observable<StrictHttpResponse<PhaseWithContent>> {
  const rb = new RequestBuilder(rootUrl, ilsControllerDuplicatePhaseToIls.PATH, 'post');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
    rb.path('sourcePhaseId', params.sourcePhaseId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PhaseWithContent>;
    })
  );
}

ilsControllerDuplicatePhaseToIls.PATH = '/ils/{ilsId}/{sourcePhaseId}/duplicate';
